import { namespace } from 'vuex-class';

export const healthReports = namespace('reports/healthReports');
